//

export default {
    name: "publicRoute",
    data() {
        return {
            loadRouter:"",//详细页路由
        };
    },
    methods:{
        doRowEdit : function() {
            this.$router.push({
                path: this.loadRouter,
            });
        },
        goBack : function() {
            this.$router.go(-1);
        },
    }
}



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/component/publicRoute.vue